// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__10HuJ","logo":"sidebar_logo__3Uyxc","menu":"sidebar_menu__Py9HT","link":"sidebar_link__ERhkT","activeLink":"sidebar_activeLink__29ip8"};